export const ERROR_CONFIG = {
  icon: 'remove',
  color: 'red',
  ttl: 1000 * 10,
};
export const WARNING_CONFIG = {
  icon: 'warning',
  color: 'yellow',
  ttl: 1000 * 10,
};
export const INFO_CONFIG = {
  icon: 'info',
  color: 'blue',
  ttl: 1000 * 10,
};
export const SUCCESS_CONFIG = {
  icon: 'checkmark',
  color: 'green',
  ttl: 1000 * 10,
};

export const MESSAGE_CONFIG = {
  ERROR: ERROR_CONFIG,
  WARNING: WARNING_CONFIG,
  INFO: INFO_CONFIG,
  SUCCESS: SUCCESS_CONFIG,
};



// WEBPACK FOOTER //
// ./src/app/components/Message/constants.js